export default __webpack_public_path__ + "static/media/icon-localisation.4960bed6.svg";